import React from "react";
import * as Sentry from "@sentry/react";
import Layout from "../layouts/index";
import HowItWorks from "../screens/Info/HowItWorks";

const HowItWorksPage = () => {
  return (
    <Layout>
      <HowItWorks />
    </Layout>
  );
};

export default HowItWorksPage;
